var map = {
	"./baijani.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/baijani.ogg",
	"./cycle.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/cycle.ogg",
	"./dhan.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/dhan.ogg",
	"./guleli.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/guleli.ogg",
	"./halojuwa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/halojuwa.ogg",
	"./hatkela.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/hatkela.ogg",
	"./himal.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/himal.ogg",
	"./junatara.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/junatara.ogg",
	"./kafal.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/kafal.ogg",
	"./kamila.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/kamila.ogg",
	"./kapas.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/kapas.ogg",
	"./karuwa.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/karuwa.ogg",
	"./katahar.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/katahar.ogg",
	"./kauli.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/kauli.ogg",
	"./kerau.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/kerau.ogg",
	"./laliguras.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/laliguras.ogg",
	"./lamkhutte.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/lamkhutte.ogg",
	"./lasun.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/lasun.ogg",
	"./makmali.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/makmali.ogg",
	"./mula.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/mula.ogg",
	"./nadinala.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/nadinala.ogg",
	"./nariwal.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/nariwal.ogg",
	"./pakhuri.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/pakhuri.ogg",
	"./rotiping.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/rotiping.ogg",
	"./sukumel.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/sukumel.ogg",
	"./tatopani.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/tatopani.ogg",
	"./telephone.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/telephone.ogg",
	"./thadeuro.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/thadeuro.ogg",
	"./thaili.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/thaili.ogg",
	"./titekarela.ogg": "./src/Containers/Play/CrosswordPuzzle/content/audios/words/titekarela.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/CrosswordPuzzle/content/audios/words sync recursive ^\\.\\/.*$";